import { GET_SOLUTIONS_BY_SLUG } from "../../operations/queries/operations/queries/get-solutions-by-slug.js";
const getSolutionsBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_SOLUTIONS_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getSolutionsBySlug
};
//# sourceMappingURL=getSolutionsBySlug.js.map
